"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
const xss_1 = __importDefault(require("xss"));
exports.defaultOptions = {
    allowList: {
        altGlyph: [],
        altGlyphDef: [],
        altGlyphItem: [],
        animate: [],
        animateColor: [],
        animateMotion: [],
        animateTransform: [],
        animation: [],
        circle: [],
        clipPath: [],
        'color-profile': [],
        cursor: [],
        defs: [],
        desc: [],
        discard: [],
        ellipse: [],
        feBlend: [],
        feColorMatrix: [],
        feComponentTransfer: [],
        feComposite: [],
        feConvolveMatrix: [],
        feDiffuseLighting: [],
        feDisplacementMap: [],
        feDistantLight: [],
        feDropShadow: [],
        feFlood: [],
        feFuncA: [],
        feFuncB: [],
        feFuncG: [],
        feFuncR: [],
        feGaussianBlur: [],
        feImage: [],
        feMerge: [],
        feMergeNode: [],
        feMorphology: [],
        feOffset: [],
        fePointLight: [],
        feSpecularLighting: [],
        feSpotLight: [],
        feTile: [],
        feTurbulence: [],
        filter: [],
        font: [],
        'font-face': [],
        'font-face-format': [],
        'font-face-name': [],
        'font-face-src': [],
        'font-face-uri': [],
        foreignObject: [],
        g: [],
        glyph: [],
        glyphRef: [],
        hkern: [],
        image: [],
        line: [],
        linearGradient: [],
        listener: [],
        marker: [],
        mask: [],
        metadata: [],
        'missing-glyph': [],
        mpath: [],
        path: [],
        pattern: [],
        polygon: [],
        polyline: [],
        prefetch: [],
        radialGradient: [],
        rect: [],
        set: [],
        solidColor: [],
        stop: [],
        style: [],
        svg: [],
        switch: [],
        symbol: [],
        tbreak: [],
        text: [],
        textArea: [],
        textPath: [],
        title: [],
        tref: [],
        tspan: [],
        use: [],
        view: [],
        vkern: [],
    },
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script'],
    onIgnoreTagAttr: (_tag, name, value) => (name.startsWith('on') ? '' : `${name}="${value}"`),
};
class SvgFileSanitizer {
    async sanitize(input) {
        return Buffer.from((0, xss_1.default)(input.toString(), exports.defaultOptions));
    }
}
exports.default = new SvgFileSanitizer();
